/* PurePetZone — filtro per stelle, "mostra altre" e apertura del modulo nelle
   recensioni.

   OGNI MODULO SI ARRANGIA DA SOLO. Prima questo file cercava un modulo solo e
   si fermava se non trovava recensioni: risultato, sulle pagine ancora senza
   recensioni il pulsante "Scrivi una recensione" non apriva niente, perche' il
   codice usciva prima di agganciarlo. Ora si aggancia a tutti i moduli in
   pagina e il modulo per scrivere funziona anche a zero recensioni, che e'
   proprio il momento in cui serve di piu'.

   Il filtro lavora sulle recensioni GIA' IN PAGINA: nessuna chiamata alla rete,
   quindi risponde nell'istante in cui si preme.

   Il conteggio in cima non lo tocca questo file: media, totale e barre li
   calcola Liquid dalle recensioni scritte, e restano quelli di tutte le
   recensioni anche mentre se ne guarda una parte sola. Se cambiassero col
   filtro, cliccando "1 stella" il prodotto sembrerebbe avere media 1. */

(function () {
  'use strict';

  var moduli = document.querySelectorAll('[data-ppz-rv]');
  if (!moduli.length) return;

  Array.prototype.forEach.call(moduli, function (radice) {
    avvia(radice);
  });

  function avvia(radice) {
    /* --- Modulo per scrivere: si aggancia SEMPRE, anche senza recensioni --- */
    var apri = radice.querySelector('[data-ppz-rv-apri]');
    var modulo = radice.querySelector('[data-ppz-rv-form]');
    if (apri && modulo) {
      apri.addEventListener('click', function () {
        modulo.hidden = !modulo.hidden;
        if (!modulo.hidden) {
          var primo = modulo.querySelector('input[type="text"], input[type="email"]');
          if (primo) primo.focus({ preventScroll: true });
          modulo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    /* --- Dettaglio per stella: si apre e chiude da "Vedi dettagli" --- */
    var dettApri = radice.querySelector('[data-ppz-rv-dettagli-apri]');
    var dett = radice.querySelector('[data-ppz-rv-dettagli]');
    if (dettApri && dett) {
      var segno = dettApri.querySelector('svg');
      dettApri.addEventListener('click', function () {
        var aperto = dett.hidden;
        dett.hidden = !aperto;
        dettApri.setAttribute('aria-expanded', aperto ? 'true' : 'false');
        /* La scritta cambia: un interruttore che dice sempre la stessa cosa non
           fa capire se sta per aprire o per chiudere. */
        dettApri.textContent = aperto
          ? dettApri.getAttribute('data-aperto')
          : dettApri.getAttribute('data-chiuso');
        if (segno) dettApri.appendChild(segno);
      });
    }

    /* --- Elenco: filtro e "mostra altre" --- */
    var lista = radice.querySelector('[data-ppz-rv-lista]');
    if (!lista) return; /* nessuna recensione: qui non c'e' altro da fare */

    var voci = Array.prototype.slice.call(radice.querySelectorAll('[data-ppz-rv-voce]'));
    var barre = Array.prototype.slice.call(radice.querySelectorAll('.ppz-rv__barra'));
    var altre = radice.querySelector('[data-ppz-rv-altre]');
    var nessuna = radice.querySelector('[data-ppz-rv-nessuna]');
    if (!voci.length) return;

    var base = parseInt(lista.getAttribute('data-visibili'), 10);
    if (isNaN(base) || base < 1) base = 5;

    /* LE RECENSIONI OLTRE LE PRIME STANNO IN UN <template>.
       Il browser lo legge ma non lo costruisce: quelle schede non esistono
       come nodi finche' non servono, quindi all'apertura non c'e' niente da
       posizionare e da disegnare. Qui dentro si spostano nell'elenco vero, un
       blocco per volta. La scheda resta disegnata solo da ppz-rec-card: qui non
       si ricostruisce niente a mano. */
    var deposito = lista.querySelector('template[data-ppz-rv-resto]');

    function inDeposito() {
      return deposito ? deposito.content.children.length : 0;
    }

    function tiraFuori(quante) {
      if (!deposito) return 0;
      var presi = 0;
      while (presi < quante) {
        var el = deposito.content.firstElementChild;
        if (!el) break;
        deposito.content.removeChild(el);
        lista.insertBefore(el, deposito);
        voci.push(el);
        presi++;
      }
      return presi;
    }

    var filtro = 'tutte';
    var limite = base;

    function disegna() {
      var mostrate = 0;
      var totali = 0;

      voci.forEach(function (v) {
        var ok = filtro === 'tutte' || v.getAttribute('data-stelle') === filtro;
        if (!ok) { v.hidden = true; return; }
        totali++;
        if (mostrate < limite) { v.hidden = false; mostrate++; }
        else { v.hidden = true; }
      });

      /* Il pulsante resta se c'e' altro da mostrare, in pagina o nel deposito. */
      if (altre) altre.hidden = totali <= mostrate && inDeposito() === 0;
      if (nessuna) nessuna.hidden = totali > 0;

      barre.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ppz-rv-filtro') === filtro ? 'true' : 'false');
      });
    }

    function cambia(valore) {
      /* Prima di filtrare si tira fuori TUTTO il deposito: altrimenti "solo 5
         stelle" cercherebbe fra le poche gia' in pagina e ne mostrerebbe una
         parte, facendo credere che siano quelle. */
      tiraFuori(inDeposito());
      filtro = valore;
      /* Si riparte dalle prime: dopo aver aperto trenta recensioni, filtrando su
         una stella si vedrebbero comunque tutte insieme. */
      limite = base;
      disegna();
    }

    /* Si filtra cliccando le barre del dettaglio: stella, numero o barra, e'
       tutto lo stesso pulsante. Ripremendo la stessa si torna a tutte. */
    barre.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ppz-rv-filtro');
        /* Senza questo controllo una barra priva di filtro faceva sparire tutte
           le recensioni: il valore nullo non corrisponde a nessuna stella,
           quindi il confronto piu' sotto falliva su ogni scheda e la lista
           restava vuota, identica per cinque, quattro e tre stelle. Meglio non
           fare niente che svuotare l'elenco. */
        if (!v) return;
        cambia(v === filtro ? 'tutte' : v);
        lista.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Ogni pressione ne aggiunge altrettante: cinque, poi dieci, poi quindici.
       Prima si alza il limite, poi si tira fuori dal deposito quanto serve per
       arrivarci. */
    if (altre) {
      altre.addEventListener('click', function () {
        limite += base;
        if (voci.length < limite) tiraFuori(limite - voci.length);
        disegna();
      });
    }

    disegna();
  }
})();
